export default __webpack_public_path__ + "static/media/diagrama_conexao.6d6ae1ab.png";